import axios from "axios";
import { toast } from "react-toastify";
import { combinedUrls } from "../../../URL/functions";
import { projectUrls } from "../../../URL/ApplicationUrls";

export const useAddSpdrOrPdsrToProject = async (
  projectId: number | undefined,
  inputValue: string
) => {
  const data = {
    Input: inputValue,
  };

  const url = combinedUrls(projectUrls.base.apiUrl, `${projectId}/AddSpdrsAndPdsrs`);
  const fetchPromise = axios.post(url, data);
  await toast.promise(fetchPromise, {
    pending: "Loading",
    success: "SPDR/PDSR has been added successfully",
    error: {
      render({ data: error }: { data: any }) {
        return `Error occurred adding SPDR/PDSR to project: ${error?.message}`;
      },
    },
  });
};
